<template>
  <auth-modal :backLinkText="backLinkText" backlink="login">
    <template v-slot:title>
      <h1>{{ $t("auth-verification-modal-title") }}</h1>
    </template>
    <template v-slot:content>
      <p>{{ $t("auth-verification-modal-text") }}</p>
    </template>
  </auth-modal>
</template>

<script>
import Base from "@/views/modules/base/Index";
import AuthModal from "@/components/AuthModal";

export default {
  name: "Verification",
  extends: Base,
  components: {
    AuthModal
  },
  computed: {
    backLinkText() {
      return this.$t("auth-verification-modal-back");
    }
  }
};
</script>

<style scoped></style>
